import Abnormal from '@/pages/dashboard/components/Abnormal';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

import React, { useContext, useMemo } from 'react';
import './index.scss';

interface IProps {
  className?: string;
  style?: any;
  w?: number;
  children: any;
  props: any;
  segmentVal?: string;
}


const RetentionChartContentCo = (colProps: IProps) => {
  const { className = '', style, children, segmentVal, ...resetProps } = colProps || {};
  const contextObj = useContext(FilterContext);
  const { filterVal = {}, filterLoading } = contextObj || {};
  const { timeType = ['Day'] } = filterVal;

  const showChildren = useMemo(() => {
    return children?.filter((item:any) => {
      return item?.props?.config?.data?.timeTypeIsShowCom?.includes(timeType?.toLowerCase());
    }) || [];
  }, [children]);

  if (segmentVal === 'all') {
    return null;
  }

  return (
    <>
      <Abnormal
        loadClassName='dbd-retention-chart-content-co-loading'
        isLoading={filterLoading}
        isError={false}
        isNoData={false}
        component={<div className={className} style={style}>
          {React.Children.map(showChildren, (child: any) => {
            return React.cloneElement(
              child,
              { ...resetProps, segmentVal }
            );
          })}
        </div>}
      />
    </>

  );
};

export default RetentionChartContentCo;
